import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';
import { LogoWithText } from '@sm/webassets';

import './simple-hero.scss';

const COPY = defineMessages({
  EU_HERO_FORM_CALLOUT_BOLD_HEADER: {
    id: 'SimpleHero.EUHeroFormCalloutBoldHeader',
    defaultMessage: 'Get answers with surveys',
    description:
      "[Type: Header][Vis: high] - The Hero's Primary tagline. A brief description of SurveyMonkey's functionality.",
  },
});

const SimpleHero = () => (
  <Container
    data-testid="SimpleHero"
    className="sm-simple-hero"
    flex
    flexDirection="column"
    flexJustify="center"
    px={3}
    py={7}
  >
    <LogoWithText color="alt" className="sm-simple-hero__logo" />
    <Container mx={1} my={7}>
      <Typography
        component="h3"
        color="light"
        variant="hero1"
        className="sm-simple-hero__text"
        align="center"
      >
        <strong>{t(COPY.EU_HERO_FORM_CALLOUT_BOLD_HEADER)}</strong>
      </Typography>
    </Container>
  </Container>
);

export default SimpleHero;
